<section class="uk-section uk-container">
  <div class="uk-magin">
    <div class="uk-flex uk-flex-center uk-margin-medium">{{mockText()}}</div>
  </div>
</section>

<app-tisco-modal></app-tisco-modal>
<div class="modal-waiting" *ngIf="loading()">
  <div class="uk-position-center">
    <div class="uk-padding-small uk-border-rounded">
      <span class="+tisco-text-white" uk-spinner="ratio: 4.5"></span>
    </div>
  </div>
</div>